import React from 'react';

import Heading from '@marvelapp/marvel-ui/heading';
import Button from '@marvelapp/marvel-ui/button';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MaxWidth from '@marvelapp/marvel-ui/max-width';

import SmartLink from 'marketing-website/components/modules/SmartLink';

export default function Maintenance() {
  const twitterLink = 'https://twitter.com/marvelapp';
  const contactLink = 'https://help.marvelapp.com/hc/en-us/requests/new';
  return (
    <Spacing type="padding" size="xl" position="topBottom">
      <Spacing type="margin" size="s" position="bottom">
        <Heading tag="h1" size="xxxl" weight="bold">
          We’ll be back soon!
        </Heading>
      </Spacing>
      <Spacing type="margin" size="m" position="bottom">
        <MaxWidth value={370}>
          <Paragraph size="l" color="slate">
            Marvel is unavailable while we switch over to the new Marvel 3 but
            we'll be back up in a few hours. In the meantime, you can read more
            on the new features and improvements and stay up to date with
            downtime updates on{' '}
            <SmartLink type="blue" url={twitterLink}>
              Twitter
            </SmartLink>
            .
          </Paragraph>
        </MaxWidth>
      </Spacing>
      <SmartLink url={contactLink}>
        <Button shape="rounded">Get in touch</Button>
      </SmartLink>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/Maintenance/index.js